// Cmd+K command palette — module navigation + recent items.
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { I } from "../shared/Icon";
import { MODULES } from "./modules";

type Props = { open: boolean; onClose: () => void };

export function CmdK({ open, onClose }: Props) {
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);
  const nav = useNavigate();

  useEffect(() => {
    if (open) { setQ(""); setSel(0); setTimeout(() => inputRef.current?.focus(), 0); }
  }, [open]);

  const results = useMemo(() => {
    const lower = q.toLowerCase();
    return MODULES.filter((m) => !q || m.label.toLowerCase().includes(lower) || m.id.toLowerCase().includes(lower));
  }, [q]);

  useEffect(() => {
    if (!open) return;
    const f = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => Math.min(results.length - 1, s + 1)); }
      if (e.key === "ArrowUp")   { e.preventDefault(); setSel((s) => Math.max(0, s - 1)); }
      if (e.key === "Enter")     { e.preventDefault(); const r = results[sel]; if (r) { nav(r.path); onClose(); } }
    };
    window.addEventListener("keydown", f);
    return () => window.removeEventListener("keydown", f);
  }, [open, sel, results, onClose, nav]);

  if (!open) return null;
  return (
    <div className="t-overlay" onClick={onClose}>
      <div className="t-cmdk" onClick={(e) => e.stopPropagation()}>
        <div className="t-cmdk-input">
          <I.Search size={16}/>
          <input ref={inputRef} value={q} onChange={(e) => { setQ(e.target.value); setSel(0); }} placeholder="모듈 · 메일 · 결재 · 파일 검색…" />
          <span className="kbd" style={{ background: "var(--panel)", padding: "2px 6px", borderRadius: 4, fontSize: 11 }}>ESC</span>
        </div>
        <div className="t-cmdk-results">
          <div className="t-cmdk-group">모듈</div>
          {results.map((r, i) => {
            const Ic = I[r.icon];
            return (
              <div
                key={r.id}
                className={`t-cmdk-item ${i === sel ? "sel" : ""}`}
                onMouseEnter={() => setSel(i)}
                onClick={() => { nav(r.path); onClose(); }}
              >
                <Ic size={16} style={{ color: r.color }}/>
                <span>{r.label}</span>
                <span className="right">{r.path}</span>
              </div>
            );
          })}
          {results.length === 0 && (
            <div style={{ padding: 24, textAlign: "center", color: "var(--text-3)" }}>일치하는 항목이 없습니다</div>
          )}
        </div>
      </div>
    </div>
  );
}
